import { ComputedRef, computed } from 'vue';
import { useTitle } from '@vueuse/core';
import { Instrument } from '@libs/api-reference';
import { numberFormatter } from '@libs/utils';

const priceChange = (symbol: Instrument) => {
  const change = symbol.referencePriceVariationPercentage || 0;

  return `${change === 0 ? '◆' : change > 0 ? '▲' : '▼'} ${Math.abs(change)}%`;
};

const stringifySymbolDetail = (symbol: Instrument) =>
  symbol.instrumentName &&
  `${symbol.instrumentName} ${numberFormatter(
    Number(symbol.lastTradePrice)
  )} ${priceChange(symbol)}`;

export default function useSyncedSymbolDetailInBrowserTitle(
  symbol: ComputedRef<Instrument>
) {
  const title = computed(() => stringifySymbolDetail(symbol.value));

  useTitle(title);
}
